/** Brand identity from the store catalog / session — not from "PG " / "DN " prefixes. */

export function storeRecordByName(name, records) {
  const key = String(name || "").trim();
  if (!key) return null;
  return (records || []).find((row) => row.location_name === key) || null;
}

export function brandKeyForStore(name, records) {
  return storeRecordByName(name, records)?.brand_key || null;
}

export function brandNameForStore(name, records) {
  return storeRecordByName(name, records)?.brand_name || null;
}

export function brandSelectOptions(brands) {
  return (brands || [])
    .filter((b) => b && b.id != null)
    .map((b) => ({ v: b.id, l: b.name || String(b.key || b.id) }));
}

export function defaultBrandId(brands) {
  const list = brands || [];
  const pg = list.find((b) => b.key === "pg");
  if (pg?.id != null) return Number(pg.id);
  const first = list[0];
  return first?.id != null ? Number(first.id) : null;
}

export function isKnownBrandId(brandId, brands) {
  const n = Number(brandId);
  if (!Number.isFinite(n)) return false;
  return (brands || []).some((b) => Number(b.id) === n);
}

export function brandKeysFromCatalog(brands, records) {
  const fromBrands = (brands || []).map((b) => b.key).filter(Boolean);
  if (fromBrands.length) return fromBrands;
  const seen = [];
  for (const row of records || []) {
    if (row?.brand_key && !seen.includes(row.brand_key)) seen.push(row.brand_key);
  }
  return seen;
}

export function brandKeyForUser(user, records, brands) {
  if (!user) return null;
  if (user.brand_key) return user.brand_key;
  const id = user.brand_id;
  if (id != null && id !== "") {
    const match = (brands || []).find((b) => Number(b.id) === Number(id));
    if (match?.key) return match.key;
  }
  return brandKeyForStore(user.store, records);
}

export function isLeavePhysicalStoreName(name, records) {
  return Boolean(brandKeyForStore(name, records));
}

export function sortLeaveStoreNames(names, records, brandKeys) {
  const keys = brandKeysFromCatalog(
    (brandKeys || []).map((k) => (typeof k === "string" ? { key: k } : k)),
    records
  );
  const list = (names || []).filter((n) => isLeavePhysicalStoreName(n, records));
  const groups = new Map();
  for (const n of list) {
    const key = brandKeyForStore(n, records) || "_";
    if (!groups.has(key)) groups.set(key, []);
    groups.get(key).push(n);
  }
  const ordered = [];
  const used = new Set();
  for (const key of keys) {
    const group = groups.get(key);
    if (!group) continue;
    ordered.push(...group.sort((a, b) => a.localeCompare(b)));
    used.add(key);
  }
  for (const [key, group] of groups) {
    if (used.has(key)) continue;
    ordered.push(...group.sort((a, b) => a.localeCompare(b)));
  }
  return ordered;
}

export function leaveStoreNamesForUser(user, catalogStoreNames, storeRecords, brands) {
  const fromCatalog = sortLeaveStoreNames(catalogStoreNames || [], storeRecords, brands);
  const role = String(user?.role || "").trim().toLowerCase();

  if (role === "admin" || role === "hr") {
    return fromCatalog;
  }

  if (role === "brand_manager") {
    const key = brandKeyForUser(user, storeRecords, brands);
    if (!key) return [];
    return fromCatalog.filter((n) => brandKeyForStore(n, storeRecords) === key);
  }

  return [];
}
